import type { Locale } from "@/lib/i18n";
import { pl, type WClientTestimonialsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wClientTestimonialsTranslations: Record<Locale, WClientTestimonialsTranslations> = {
  pl,
  en,
  de,
};

export type { WClientTestimonialsTranslations };
